import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { userFromSession } from '../../utils/verification';
import { isTawkConfigured, syncTawk, tawkVisitor } from '../../utils/tawk';

/**
 * Mounts the Tawk widget and keeps its visitor identity in step with the
 * signed-in account (#152). Renders nothing — Tawk draws its own bubble.
 */
const TawkChat = () => {
	const { user } = useSelector((state) => state.user);
	// A stable key: the visitor object is rebuilt every render, so the effect
	// must key off its contents rather than its identity.
	const visitorKey = JSON.stringify(tawkVisitor(userFromSession(user)));

	useEffect(() => {
		if (!isTawkConfigured()) return;
		syncTawk(JSON.parse(visitorKey));
	}, [visitorKey]);

	return null;
};

export default TawkChat;
